module.exports = __webpack_public_path__ + "static/media/banner.e00e1073.png";